export enum MigrationDateFilter {
    LESS_THAN = 'LESS_THAN',
    BETWEEN = 'BETWEEN',
    MORE_THAN = 'MORE_THAN'
}

